import { getGroupTypesUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class CourseGroupTypeService {
  static getGroupTypes = () => {
    return getRequest(getGroupTypesUrl());
  };

  static createGroupTypes = (groupTypes) => {
    return postRequest(getGroupTypesUrl(), groupTypes);
  };

  static getGroupTypeById = (groupTypeId) => {
    return Promise.resolve(getRequest(getGroupTypesUrl() + "/" + groupTypeId));
  };

  static updateGroupType = (groupType) => {
    return putRequest(getGroupTypesUrl() + "/" + groupType.id, groupType);
  };

  static deleteGroupTypeById = (groupTypeId) => {
    return deleteRequest(getGroupTypesUrl() + "/" + groupTypeId);
  };
}
